import { useEffect } from 'react';
/**
 * While `active`, the browser asks before the tab is closed or reloaded, and
 * stops asking the moment `active` goes false. The prompt's wording is the
 * browser's own — modern browsers ignore any message a page supplies — so this
 * takes none. `preventDefault()` is the standard trigger; `returnValue` is set
 * as well for the browsers that still only honour the legacy form.
 */
export function useBeforeUnloadGuard(active) {
    useEffect(() => {
        if (!active)
            return;
        const handler = (event) => {
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, [active]);
}
